import "./SpotDifference.scss";
import { useState } from "react";
import Party from "./Party";
import gilmoreOriginal from "../resources/videos/gilmoreHouse.jpg";
import gilmoreAltered from "../resources/videos/gilmoreHouse2.png";
import kimOriginal from "../resources/videos/kimStore.png";
import kimAltered from "../resources/videos/KimStore2.png";
import restaurantOriginal from "../resources/videos/restaurant.jpg";
import restaurantAltered from "../resources/videos/restaurant2.png";

// One difference per image. Each spot is its centre, in % of the image box,
// plus the radius (as % of the image width) that counts as a hit - measured
// against the two files, so a click that looks right is a click that counts.
const LEVELS = [
  {
    name: "La casa",
    original: gilmoreOriginal,
    altered: gilmoreAltered,
    spots: [{ x: 90, y: 80, r: 9 }], // the ivy-covered stone wall
  },
  {
    name: "La botiga de la Sra. Kim",
    original: kimOriginal,
    altered: kimAltered,
    spots: [{ x: 79.5, y: 76, r: 6 }], // the blue book on the table
  },
  {
    name: "El restaurant",
    original: restaurantOriginal,
    altered: restaurantAltered,
    spots: [{ x: 75.5, y: 83.8, r: 9 }], // a plate of food on the table
  },
];

function SpotDifference({ onFinish }) {
  const [level, setLevel] = useState(0);
  const [found, setFound] = useState([]);
  const [miss, setMiss] = useState(null);
  const [party, setParty] = useState(false);

  const current = LEVELS[level];
  const complete = found.length === current.spots.length;
  const lastLevel = level === LEVELS.length - 1;

  const goOn = () => {
    if (lastLevel) {
      setParty(true);
      return;
    }
    setFound([]);
    setMiss(null);
    setLevel((old) => old + 1);
  };

  const handleClick = (event, board) => {
    if (complete) return;

    // Work in pixels: x and y percentages are relative to different edges, so
    // comparing them directly would make the hit area an ellipse.
    const box = event.currentTarget.getBoundingClientRect();
    const clickX = event.clientX - box.left;
    const clickY = event.clientY - box.top;

    const hit = current.spots.findIndex((spot, i) => {
      if (found.includes(i)) return false;
      const dx = clickX - (spot.x / 100) * box.width;
      const dy = clickY - (spot.y / 100) * box.height;
      return Math.sqrt(dx * dx + dy * dy) <= (spot.r / 100) * box.width;
    });

    if (hit === -1) {
      setMiss({ board, x: (clickX / box.width) * 100, y: (clickY / box.height) * 100 });
      setTimeout(() => setMiss(null), 600);
    } else {
      setFound((old) => [...old, hit]);
    }
  };

  const board = (index, src, alt) => (
    <div className="spot__frame" onClick={(e) => handleClick(e, index)}>
      <img className="spot__image" src={src} alt={alt} draggable="false" />
      {found.map((i) => (
        <span
          key={i}
          className="spot__mark"
          style={{
            left: `${current.spots[i].x}%`,
            top: `${current.spots[i].y}%`,
            width: `${current.spots[i].r * 2}%`,
          }}
        />
      ))}
      {miss && miss.board === index && (
        <span className="spot__miss" style={{ left: `${miss.x}%`, top: `${miss.y}%` }} />
      )}
    </div>
  );

  if (party) return <Party onFinish={onFinish}></Party>;

  return (
    <div className="spot">
      <header className="spot__header">
        <h1 className="spot__title">Troba la diferència</h1>
        <p className="spot__score">
          {current.name} ({level + 1}/{LEVELS.length})
          {current.spots.length > 1 &&
            ` — ${found.length} de ${current.spots.length}`}
        </p>
      </header>

      <div className="spot__boards">
        {board(0, current.original, "original")}
        {board(1, current.altered, "amb diferències")}
      </div>

      {complete && (
        <div className="spot__done">
          <p>Molt bé!</p>
          <button className="restart-button" onClick={goOn}>
            {lastLevel ? "Continuar" : "Següent"}
          </button>
        </div>
      )}
    </div>
  );
}
export default SpotDifference;
